module.exports = __webpack_public_path__ + "img/837003190_10.1803252d.jpg";